export const AUTH_PAGE_CARDS = [
  {
    id: 'audio-tools',
    image: '/audiotoolscard.png',
    alt: 'Audio tools',
  },
  {
    id: 'text-tools',
    image: '/texttoolscard.png',
    alt: 'Text tools',
  },
  {
    id: 'text-to-image',
    image: '/texttoimagecard.png',
    alt: 'Text to Image',
  },
  {
    id: 'social-media',
    image: '/socialmediacard.png',
    alt: 'Social Media',
  },
  {
    id: 'brandbook',
    image: '/brandbookcard.png',
    alt: 'Brandbook',
  }
]; 